import { Divider } from 'antd'

import { CovidInsurance } from './CovidInsurance'
import { InsuranceAmount } from './InsuranceAmount'
import { InsuranceCountriesSelect } from './InsuranceCountriesSelect'
import { InsuranceDates } from './InsuranceDates'
import { InsuredPersons } from './InsuredPersons'
import { PeopleAreInCountry } from './PeopleAreInCountry'
import { PurposeOfTrip } from './PurposeOfTrip'
import { TripType } from './TripType'

export const MainStep = () => {
  return (
    <>
      <InsuranceCountriesSelect />
      <InsuranceAmount />
      <PeopleAreInCountry />
      <TripType />
      <InsuranceDates />
      <PurposeOfTrip />
      <CovidInsurance />
      <Divider />
      <InsuredPersons />
    </>
  )
}
